// TODO: Refactor this soon for the Blue Wings footer offer and merge the logic either into FooterOfferComponent or into the template using it.
// This component is currently not referred to in cms.module.ts or index.ts.
import { Component, Input, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { Observable, Subscription, filter, map, take } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';
import { Amount } from '@fcom/dapi';
import { LocationRouteCffService } from '@fcom/core/services';
import { GlobalBookingTravelClass } from '@fcom/core';
import { unsubscribe } from '@fcom/core/utils';

import { CheapestPriceForAllDestinationsService } from '../../services';
import { FooterOffer, MarketingOffer } from '../../interfaces';

@Component({
  selector: 'cms-book-now',
  template: `
    @if (price$ | async) {
      <fin-footer-offer [offer]="offer" />
    }
  `,
  styleUrls: ['./cms-book-now.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsBookNowComponent implements OnInit, OnDestroy {
  private cheapestPriceForAllDestinationsService = inject(CheapestPriceForAllDestinationsService);
  private locationRouteCffService = inject(LocationRouteCffService);
  private languageService = inject(LanguageService);

  offer: FooterOffer;
  price$: Observable<Amount>;

  @Input()
  locationCode: string;

  private subscription = new Subscription();

  ngOnInit(): void {
    this.offer = {
      locationCode: this.locationCode,
      location: '',
    };

    if (this.locationCode) {
      this.subscription.add(
        this.locationRouteCffService
          .bestGuessFor(this.locationCode, this.languageService.localeValue)
          .pipe(take(1))
          .subscribe((res) => {
            this.offer.location = res.title;
          })
      );
    }

    this.price$ = this.cheapestPriceForAllDestinationsService.offerForSingleTrip(this.offer.locationCode, true).pipe(
      map(
        (offer: MarketingOffer) =>
          offer.prices.find((t) => t.travelClass.toUpperCase() === GlobalBookingTravelClass.ECONOMY)?.price
      ),
      filter<Amount>(Boolean)
    );
  }

  ngOnDestroy(): void {
    this.subscription = unsubscribe(this.subscription);
  }
}
